import { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'
import { connect } from 'react-redux'
import WeaverService from 'Services/WeaverService'

EmbeddedComponentWrapper = ({ Component, currentProject }) ->

  [loading, setLoading] = useState(true)
  { params: { spaceId }} = useRouteMatch()

  useEffect( ->
    ( ->
      project = await Weaver.Project.load(spaceId or currentProject)
      await WeaverService.setProject(project)
      setLoading(false)
    )()
    undefined
  , [currentProject])

  if loading
    null
  else
    <Component />

export default connect(({ projects: { currentProject }}) ->
  { currentProject }
, { }
)(EmbeddedComponentWrapper)
